import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { ErrorService } from '../../../../@core/utils/error.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { ContractDTO } from '../models/contract';
import { ContractLine } from '../models/lineItem';

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
    private errorService: ErrorService
  ) {
    // this.basePath = environment.HOLLINGBERY_API_URL;
    this.basePath = environment.PLATFORM_API_URL;


  }

  public getContractTemplates(): Observable<any> {
    return this.httpClient.get<any>(`${this.basePath}/api/contracttemplate`);
  }
  public getContracts(): Observable<ContractDTO> {
    return this.httpClient.get<ContractDTO>(`${this.basePath}/api/contract`);
  }

  public getCustomerContracts(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.basePath}/api/contract/Current/${id}`);
  }

  public deleteContract(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/contract/${id}`);
  }

  public getContractById(id: number): Observable<ContractDTO> {
    return this.httpClient.get<ContractDTO>(`${this.basePath}/api/contract/${id}`);
  }
  public getLastContractId(): Observable<number> {
    return this.httpClient.get<number>(`${this.basePath}/api/contract/lastId`);
  }

  public postContract(dto: ContractDTO): Observable<ContractDTO> {
    return this.httpClient.post<ContractDTO>(`${this.basePath}/api/contract`, dto);
  }
  public putContract(dto: ContractDTO, id: number, saveERPFlag?: boolean): Observable<ContractDTO> {
    let queryParameters = new HttpParams();
    if (saveERPFlag)
      queryParameters = queryParameters.set("saveERPFlag", saveERPFlag.toString());

    return this.httpClient.put<ContractDTO>(`${this.basePath}/api/contract/${id}`, dto,
      {
        params: queryParameters
      }
    );
  }



  // public postContractLine(dto: ContractLine): Observable<ContractLine> {

  //   let headers = this.defaultHeaders;

  //   headers = headers.set('Authorization', String(this.authService.getUserToken()));

  //   const httpHeaderAcceptSelected: string | undefined = 'application/json';
  //   if (httpHeaderAcceptSelected !== undefined) {
  //     headers = headers.set('Accept', httpHeaderAcceptSelected);
  //   }

  //   // to determine the Content-Type header
  //   const consumes: string[] = [
  //   ];
  //   return this.httpClient.post<ContractLine>(`${this.basePath}/api/contractLines`, dto,

  //     {
  //       headers,
  //     }
  //   );
  // }
}
